<template>
  <div class="stepsdemo-content">
    <Card>
      <template #title> Informações do Evento </template>
      <template #subtitle>
        Preencha os campos para dar prosseguimento a solicitação de agendamento.
      </template>
      <template #content>
        <div class="p-fluid">
          <div class="grid">
            <event-form-info-vue :event="obj" :submitted="submitted" />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="grid grid-nogutter justify-content-between">
          <Button
            label="Voltar"
            @click="prevPage()"
            icon="pi pi-angle-left"
            iconPos="left"
          />
          <Button
            label="Próximo"
            @click="nextPage(!v$.$invalid)"
            icon="pi pi-angle-right"
            iconPos="right"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

//COMPONENTS
import EventFormInfoVue from "../../calendar/components/event-form-info.vue";
import Event from "../../../models/internal/event";

export default {
  props: ["formObject"],
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    EventFormInfoVue,
  },
  data() {
    return {
      pageIndex: 1,
      submitted: false,
      obj: new Event(),
    };
  },
  created() {
    if (this.formObject.length !== 0) {
      this.obj = this.formObject;
    }
  },
  methods: {
    nextPage(isFormValid) {
      this.submitted = true;
      if (!isFormValid) {
        return;
      }
      this.$emit("nextPage", {
        formData: this.obj,
        pageIndex: this.pageIndex,
      });
    },
    prevPage() {
      this.$emit("prevPage", {
        formData: this.formObject,
        pageIndex: this.pageIndex,
      });
    },
  },
};
</script>

<style></style>
